import axios from "axios";
import React, { useState, useEffect, Link } from 'react';
import { Cookies } from '../../index.js';
import { alert_error, alert_success } from '../../AppContext';
function Buylink({ money, hustmediavipro, capdo }) {
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
    const newbie_buff = Cookies.get('newbie_buff');
    function handleSubmit(event) {
        setnutxuly(0);
        const apikey = Cookies.get('apikey');
        event.preventDefault();

        setnutxuly(1);
        setnutorder('Please wait a moment 😊');
        if (!hustmediavipro) {
            alert_error('Please điền đầy đủ thông tin')
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return
        }
        axios
            .post('https://hust.media/link/load_logic/buy_link.php', {
                lienket: hustmediavipro,
                apikey: apikey
            })
            .then(response => (testFunction(response)))
            .catch(error => console.log(error))

    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        setnutorder('đặt tiếp luôn nào')
        setnutxuly(0);
        if (status == 0) {
            alert_error(info.message);
        }
        else if (status == 1) {
            alert_success(info.message);
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1500);
        }
    };
    return (
        <>
            <div>Mua link ngay</div>
            <div className="inline-flex items-center justify-center space-x-4">
                <div>Giá: {money} Coins</div>
                {
                    newbie_buff == 'YES' && (<div className="text-xs">Bạn mới free 2 lần</div>)
                }
            </div>

            <div className="mx-auto max-w-md">
                <button disabled={nutxuly == 1}
                    onClick={handleSubmit}
                    className='flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2  w-full dark:bg-slate-800 dark:text-white'>
                    <div className='flex items-center justify-between flex-1'>
                        {nutxuly == 1 &&
                            <div className="spinner-border" role="status">
                            </div>}
                        <span className='text-lg font-medium text-white'>
                            {nutorder} </span>
                            <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                    </div>
                </button>
            </div>
            {capdo != 8 && (
                <div>Hoặc :</div>
            )}
        </>
    );
}
export default Buylink;